<!-- 资料下载弹框 -->
<template>
  <van-popup v-model="dataPopup_" position="bottom" :style="{ height: '60%' }" :close-on-click-overlay='false'
    :close-on-popstate="true">
    <div class="popWrapper" v-show="!showList">
      <div class="title">
        弘知教育内部资料，请登记后查看
      </div>
      <div class="opt-form-con">
        <form class="opt-form">

          <div class="form-item df ji_c ai_c">
            <div class="form-item-label">
              <span class="form-item-label-title">
                姓名
              </span>
              <span class="form-item-label-require">*</span>
            </div>
            <input type="text" autocomplete="off" name="registerName" placeholder="请输入孩子姓名" title="姓名" required
              minlength="2" maxlength="50" v-model="registerObj.registerName">
          </div>

          <div class="form-item df ji_c ai_c">
            <div class="form-item-label">
              <span class="form-item-label-title">
                手机
              </span>
              <span class="form-item-label-require">*</span>
            </div>
            <input type="number" autocomplete="off" name="tel" placeholder="请输入常用手机号" title="手机" required minlength="11"
              maxlength="11" v-model="registerObj.tel">
          </div>

          <div class="form-item df ji_c ai_c">
            <div class="form-item-label">
              <span class="form-item-label-title">
                验证码
              </span>
              <span class="form-item-label-require">*</span>
            </div>
            <input type="text" inputmode="numeric" autocomplete="off" name="codeNumber" class="msgCode" placeholder="验证码" title="验证码" required
              v-model="registerObj.codeNumber" maxlength="6" ref="ipt">
            <span class="msgCodeBtn" :class="this.isDisabled ? '' : 'disabled'" @click="getmsgCode"
              v-if="show == 0">获取验证码</span>
            <span class="msgCodeBtn" :class="this.isDisabled ? '' : 'disabled'" v-if="show == 1">已发送{{ count }}秒</span>
            <span class="msgCodeBtn" :class="this.isDisabled ? '' : 'disabled'" @click="getmsgCode"
              v-if="show == 2">重新获取</span>
          </div>

          <div class="form-item df ji_c ai_c" @click="showGradeList">
            <div class="form-item-label">
              <span class="form-item-label-title">
                年级
              </span>
              <span class="form-item-label-require">*</span>
            </div>
            <div class="common-placeholder" :class="registerObj.grade ? 'color_666' : ''">
              {{ registerObj.grade ? registerObj.grade : '请选择孩子年级' }}
            </div>
            <div class="item-arrow"></div>
          </div>

          <div class="form-item df ji_c ai_c" @click="showStudentArea" v-show="pagesObj.studentArea !== '0'">
            <div class="form-item-label">
              <span class="form-item-label-title">
                区域
              </span>
              <span class="form-item-label-require" v-show="pagesObj.studentArea == '1'">*</span>
            </div>
            <div class="common-placeholder" :class="registerObj.region ? 'color_666' : ''">
              {{ registerObj.region ? registerObj.region : '请选择区域' }}
            </div>
            <div class="item-arrow"></div>
          </div>

          <div class="form-item checkbox-con" v-show="pagesObj.mainSubject !== '0'">
            <div class="form-item-label form-check-label">
              <span class="form-item-label-title">
                科目选择
              </span>
              <span class="form-item-label-require" v-show="pagesObj.mainSubject == '1'">*</span>
            </div>
            <van-radio-group v-model="registerObj.mainSubject" direction="horizontal"
              :class="registerObj.mainSubject ? 'radioBox-name' : ''" @change="mainSubChange">
              <van-radio name="物理" checked-color="#4BDFA8" icon-size="16px">物理</van-radio>
              <van-radio name="历史" checked-color="#4BDFA8" icon-size="16px">历史</van-radio>
            </van-radio-group>
            <van-checkbox-group :max="2" v-show="registerObj.mainSubject" v-model="radioValue" direction="horizontal"
              @change="mainSubChange">
              <van-checkbox name="化学" shape="square" icon-size="16px" checked-color="#4BDFA8">化学</van-checkbox>
              <van-checkbox name="生物" shape="square" icon-size="16px" checked-color="#4BDFA8">生物</van-checkbox>
              <van-checkbox name="政治" shape="square" icon-size="16px" checked-color="#4BDFA8">政治</van-checkbox>
              <van-checkbox name="地理" shape="square" icon-size="16px" checked-color="#4BDFA8">地理</van-checkbox>
            </van-checkbox-group>
          </div>

          <div class="form-item checkbox-con" v-show="pagesObj.otherSubject !== '0'">
            <div class="form-item-label form-check-label">
              <span class="form-item-label-title">
                弱项学科
              </span>
              <span class="form-item-label-require" v-show="pagesObj.otherSubject == '1'">*</span>
            </div>
            <van-checkbox-group v-model="otherChckList" direction="horizontal">
              <van-checkbox @click="choseOtherSubItem()" v-for="(item, index) in otherSubList" :key="index"
                :name="item.name" shape="square" icon-size="16px" checked-color="#4BDFA8">{{ item.name }}</van-checkbox>
            </van-checkbox-group>
          </div>

          <van-button round type="info" color="linear-gradient(90deg, #53d484, #28cfb9)" class="subBtn"
            @click="submitForm">提交</van-button>
        </form>
      </div>
    </div>

    <!-- list列表 -->
    <div class="item-list" v-show="showList">
      <div class="item-list-close" @click="showList = false">
      </div>
      <div class="item-list-title">
        <span>{{ title }}</span>
      </div>
      <div class="item-list-bar">
        <div class="item-bar-item active" v-show="title == '年级'">
          {{ gradeList[gradeIndex] ? gradeList[gradeIndex] : '请选择' }}
        </div>
        <div class="item-bar-item active" v-show="title == '区域'">
          {{ studentAreaList[studentAreaIndex] ? studentAreaList[studentAreaIndex] : '请选择' }}
        </div>
      </div>
      <div class="item-list-content" v-if="title == '年级'">
        <div class="list-item" :class="index == gradeIndex && clickGrade ? 'active' : ''"
          v-for="(item, index) in gradeList" :key="index" @click="choseGradeItem(index)">
          {{ item }}
        </div>
      </div>
      <div class="item-list-content" v-if="title == '区域'">
        <div class="list-item" :class="index == studentAreaIndex && clickStudentArea ? 'active' : ''"
          v-for="(item, index) in studentAreaList" :key="index" @click="choseStudentAreaItem(index)">
          {{ item }}
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { pagesDetail, getCode, register } from "@/request/api";
export default {
  props: {
    dataPopup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isDisabled: false,
      showList: false,
      radioValue: [],
      pagesObj: {},
      pageId: "",
      registerObj: {
        registerName: "",
        tel: "",
        grade: "",
        otherSubject: "", //弱科
        mainSubject: "", //科目选择
        region: "", //区域
      },
      show: 0,
      count: "",
      timer: null,
      mainSubject: "",
      title: "",
      gradeList: [],
      studentAreaList: [
        "岳麓区",
        "芙蓉区",
        "天心区",
        "望城区",
        "开福区",
        "雨花区",
        "长沙县",
        "高新区",
      ],
      otherSubList: [
        {
          name: "语文",
          active: false,
        },
        {
          name: "数学",
          active: false,
        },
        {
          name: "英语",
          active: false,
        },
        {
          name: "历史",
          active: false,
        },
        {
          name: "化学",
          active: false,
        },
        {
          name: "物理",
          active: false,
        },
        {
          name: "化学",
          active: false,
        },
        {
          name: "政治",
          active: false,
        },
        {
          name: "地理",
          active: false,
        },
      ],
      gradeIndex: null,
      clickGrade: false,
      clickOtherSub: false,
      dataPopup_: false,
      otherChckList: [],
      studentAreaIndex: null,
      clickStudentArea: false,
    };
  },
  watch: {
    "registerObj.tel"(newVal, oldVal) {
      let isDisabled =
        /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(
          newVal
        );
      this.isDisabled = isDisabled;
    },
    dataPopup(newName, oldName) {
      this.dataPopup_ = newName;
    },
  },
  created() {
    var url = window.location.href; //获取当前url
    let { pageId } = this.queryURLParams(url);
    this.pageId = pageId;

    if (pageId) {
      this.getList();
    }
  },
  methods: {
    //选择弱项学科
    choseOtherSubItem() {
      this.registerObj.otherSubject = this.otherChckList.toString();
    },
    //选择年级
    choseGradeItem(index) {
      this.registerObj.grade = this.gradeList[index];
      this.clickGrade = true;
      this.gradeIndex = index;

      this.showList = false;
    },
    //选择区域
    choseStudentAreaItem(index) {
      this.registerObj.region = this.studentAreaList[index];
      this.clickStudentArea = true;
      this.studentAreaIndex = index;

      this.showList = false;
    },
    // 展示区域列表
    showStudentArea() {
      this.showList = true;
      this.title = "区域";
    },
    // 展示年级列表
    showGradeList() {
      this.showList = true;
      this.title = "年级";
    },
    // 科目选择change事件
    mainSubChange() {
      let checkVal = this.radioValue.toString();
      let { mainSubject } = this.registerObj.mainSubject;
      if (mainSubject == "物理") {
        mainSubject = "物理,";
      } else {
        mainSubject = "历史,";
      }
      mainSubject += checkVal;
      this.mainSubject = mainSubject;
    },
    // 禁止表单提交时刷新页面
    disableRefresh() {
      var form = document.getElementsByTagName("form")[0];
      form.addEventListener("submit", function (e) {
        var event = e || window.event;
        event.preventDefault();
      });
    },
    // 提交资料
    async submitForm() {
      this.disableRefresh();

      let {
        registerName,
        tel,
        codeNumber,
        grade,
        mainSubject,
        otherSubject,
        region,
      } = this.registerObj;

      if (!registerName || !tel || !codeNumber) {
        return;
      } else if (tel.length < 11) {
        return;
      } else if (!grade) {
        this.$toast("年级不能为空");
        return;
      }

      if (!mainSubject) {
        if (this.pagesObj.mainSubject == "1") {
          this.$toast("科目选择不能为空");
          return;
        }
      }
      if (!region) {
        if (this.pagesObj.studentArea == "1") {
          this.$toast("区域选择不能为空");
          return;
        }
      }

      if (!otherSubject) {
        if (this.pagesObj.otherSubject == "1") {
          this.$toast("弱项学科选择不能为空");
          return;
        }
      }

      let obj = Object.assign({}, this.registerObj);
      obj.mainSubject = this.mainSubject;

      const res = await register(obj);
      if (res.data.code !== 0) {
        this.$toast(res.data.msg);
        return;
      }
      this.$toast("提交成功");
      this.dataPopup_ = false;
      localStorage.setItem("iphoneNum", this.registerObj.tel);

      //给父组件提示已登录，显示按钮
      this.$emit("isLand", true);
    },
    // 获取验证码
    getmsgCode() {
      if (!this.isDisabled) {
        return;
      }

      this.$refs.ipt.focus()

      let p = "phone=" + this.registerObj.tel;
      getCode(p).then((res) => {
        if (res.data.code == 0) {
          this.$toast("验证码发送成功");
        }

        const times = 60; // 倒计时时间
        if (!this.timer) {
          this.count = times;
          this.show = 1;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= times) {
              this.count--;
            } else {
              this.show = 2;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      });
    },
    async getList() {
      const res = await pagesDetail("pageId=" + this.pageId);
      this.pagesObj = res.data.data;
      this.registerObj.pageId = this.pageId;
      this.gradeList = res.data.data.studentGrade.split(",");
    },
  },
};
</script>
<style scoped>
.popWrapper {
  /* overflow-y: scroll; */
}

.popWrapper .title {
  margin-top: 1.4375rem;
  margin-bottom: 0.25rem;
  font-size: 1.0625rem;
  font-weight: bold;
  color: #333;
  text-align: center;
}

.opt-form {
  border-radius: 20px 20px 0 0;
  padding: 20px 20px;
  position: relative;
  z-index: 10;
  background: #fff;
}

.opt-form-con .form-item {
  position: relative;
  font-size: 16px;
  height: 52px;
  border-bottom: 0.5px solid #e3e3e3;
}

.form-item .form-item-label {
  min-width: 75px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1;
  flex-shrink: 0;
  padding-right: 10px;
}

.form-item-label .form-item-label-title {
  color: #333;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 1px;
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: PingFang-SC-Medium, PingFang-SC;
}

.form-item-label .form-item-label-require {
  color: #f15b38;
}

.form-item input,
select {
  position: relative;
  display: block;
  height: 100%;
  width: 73%;
  background: none;
  color: inherit;
  opacity: 1;
  font: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  text-align: inherit;
  text-indent: inherit;
  text-transform: inherit;
  text-shadow: inherit;
  outline: none;
  border: none;
  padding: 0;
  margin: 0;
  text-decoration: inherit;
  line-height: 1;
}

input::-webkit-input-placeholder {
  color: #c9c9c9;
}

.form-item input.msgCode {
  width: 180px;
  float: left;
}

.form-item .msgCodeBtn {
  position: absolute;
  width: 90px;
  height: 30px;
  font-size: 12px;
  color: #1fb895;
  line-height: 30px;
  background: #ecfef4;
  border-radius: 15px;
  text-align: center;
  right: 0;
}

.form-item .msgCodeBtn.disabled {
  background: #f3f3f3;
}

.form-item .msgCodeBtn.disabled,
.common-placeholder {
  color: #ccc;
}

.form-item .common-placeholder {
  font-size: 16px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 400;
}

.form-item .item-arrow {
  width: 8px;
  height: 12px;
  background: url("../assets/images/arrow.png") 100%/100% no-repeat;
  margin-left: auto;
}

.item-list {
  /* position: fixed; */
  height: 50%;
  width: 100%;
  bottom: -50%;
  left: 0;
  background: #fff;
  border-radius: 10px 10px 0 0;
  z-index: 1000;
  box-sizing: border-box;
  padding: 20px 16px 100px;
  bottom: 0px;
  transition: bottom 300ms ease-out 300ms, transform 300ms ease-out 300ms;
  transform-origin: 50% 50% 0px;
}

.item-list .item-list-close {
  position: absolute;
  width: 17px;
  height: 17px;
  top: 25px;
  right: 16px;
  background: url("../assets/images/close.png");
  background-size: cover;
}

.item-list .item-list-title {
  font-size: 20px;
  line-height: 44px;
  font-weight: 500;
}

.item-list .item-list-bar {
  height: 43px;
  display: flex;
  font-size: 14px;
  align-items: center;
  margin-top: 6px;
  margin-bottom: 10px;
}

.item-list-bar .item-bar-item.active {
  font-weight: 500;
  font-size: 16px;
  color: #333;
  display: block;
  margin-right: 0;
  position: relative;
}

.item-list-bar .item-bar-item.active:after {
  content: "";
  position: absolute;
  background: #1fb895;
  width: 20px;
  height: 3px;
  bottom: -7px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 5px;
}

.item-list-content {
  position: absolute;
  top: 120px;
  padding: 0 17px;
  bottom: 5px;
  left: 0;
  right: 0;
  /* width: 80%; */
  overflow: hidden;
  font-size: 14px;
  overflow: scroll;
  top: 130px;
}

.item-list-content .list-item {
  height: 48px;
  line-height: 48px;
  position: relative;
  font-weight: 400;
}

.item-list-content .list-item:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.5px;
  transform: scaleY(0.5);
  background: #e3e3e3;
}

.item-list-content .list-item.active {
  color: #1fb895;
}

.opt-form .checkbox-con {
  height: auto;
  padding-bottom: 16px;
}

.checkbox-con .form-item-label .form-item-label-title {
  font-weight: 400;
}

.checkbox-con .form-item-label {
  line-height: 43px;
}

:deep.form-item .van-radio__label,
:deep.form-item .van-checkbox__label {
  font-size: 14px;
}

.form-item .radioBox-name {
  padding-bottom: 14px;
}

:deep.opt-form .subBtn {
  margin: 30px auto 0;
  box-shadow: 0 4px 11px 0 rgb(22 205 199 / 44%);
  border-radius: 27px;
  width: 100%;
}

.color_666 {
  color: #666666;
}

.item-list-content .van-cell {
  padding: 10px 0;
}

.item-list-content [class*="van-hairline"]::after {
  border: none;
}

.checkbox-con .van-checkbox--horizontal {
  margin-bottom: 3px;
}
</style>